import script from "./SettingsLocationsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsLocationsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsLocationsSection.vue?vue&type=style&index=0&id=5ea382f3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea382f3"]])

export default __exports__